export type UsersCollectionQuery = {
    page: number;
    itemsPerPage?: number;
    search?: string;
    onlyActive?: boolean;
};

export function canAccessAllUsers(isAdmin: boolean, groupementId?: number): boolean {
    return isAdmin || groupementId === 1;
}

export function buildUsersCollectionUrl(
    isAdmin: boolean,
    groupementId: number | undefined,
    query: UsersCollectionQuery,
): string {
    const searchParams = new URLSearchParams({ page: String(query.page) });
    const hasGlobalAccess = canAccessAllUsers(isAdmin, groupementId);

    if (query.itemsPerPage !== undefined) {
        searchParams.set('itemsPerPage', String(query.itemsPerPage));
    }

    if (query.search) {
        searchParams.set('search', query.search);
    }

    if (!hasGlobalAccess) {
        searchParams.set('groupement.id', String(groupementId ?? 0));
        searchParams.set('isActive', '1');
    } else if (query.onlyActive) {
        searchParams.set('isActive', '1');
    }

    return `/api/users?${searchParams.toString()}`;
}
